import React from "react";
import "../styles/services.css";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const Services: React.FC = () => {
  return (
    <>
      <header
        className="hero"
        style={{
          backgroundImage: "url(/images/header.jpg)",
          backgroundSize: "cover",
          backgroundPosition: "center",
          height: "50vh",
          minHeight: 0,
          overflow: "hidden"
        }}
      >
        <Navbar />
        <div className="hero-content">
          <div className="hero-text">
            <h1>Hizmetlerimiz</h1>
          </div>
        </div>
      </header>
      <div className="services-wrapper">
      <section className="hizmet-container">
        <div className="circle-image">
          <img id="circle-img" src="/images/header3.jpg" alt="Elektrik Bölümü Görseli" />
        </div>
        <div className="hizmet-content">
          <h2>Elektrik Bölümü</h2>
          <div className="orange-line"></div>
          <p>Elektrik alanında uzman ekibimizle, hem iç hem de dış mekan projeleriniz için kapsamlı hizmetler sunuyoruz. Bahçe aydınlatma sistemleriyle açık alanlarınızı estetik ve güvenli bir şekilde aydınlatırken, enerji verimliliğini ön planda tutuyoruz. Elektrik kablo döşeme hizmetimizle projelerinizin altyapısını güvenli ve standartlara uygun şekilde hazırlıyoruz. Yeni inşaatlar için elektrik tesisatı döşeme, mevcut tesisatlarda ise elektrik tesisatı tamiri hizmetleri veriyoruz. Modern ve şık LED aydınlatma çözümleri ile hem ev hem de iş yerlerinize enerji tasarrufu sağlayan, uzun ömürlü aydınlatma sistemleri kuruyoruz. Ayrıca, iç mekan aydınlatma projelerinizde dekoratif ve fonksiyonel çözümler sunarak yaşam alanlarınıza değer katıyoruz.</p>
        </div>
      </section>
      <section className="hizmet-container">
        <div className="hizmet-content">
          <h2>CCTV, Ip ve Telefon</h2>
          <div className="orange-line"></div>
          <p>Güvenlik ve iletişim altyapılarında modern teknolojiye uygun çözümler sağlıyoruz. IP tabanlı CCTV kamera sistemleri ile yüksek çözünürlüklü, uzaktan erişilebilir ve güvenilir güvenlik altyapıları oluşturuyoruz. Sistem kurulumu, kablolama ve cihaz entegrasyonu dahil olmak üzere tüm süreci profesyonel şekilde yürütüyor, devreye alma işlemlerini eksiksiz gerçekleştiriyoruz. Ev, iş yeri, fabrika ve diğer ticari alanlarda güvenliği en üst düzeye çıkaracak sistemleri sizin için tasarlıyoruz.</p>
        </div>
        <div className="circle-image">
          <img id="circle-img" src="/images/header3.jpg" alt="CCTV, Ip ve Telefon Görseli" />
        </div>
      </section>
      <section className="hizmet-container">
        <div className="circle-image">
          <img id="circle-img" src="/images/header3.jpg" alt="Alt Yapı ve Kablolama Görseli" />
        </div>
        <div className="hizmet-content">
          <h2>Alt Yapı ve Kablolama</h2>
          <div className="orange-line"></div>
          <p>İletişim ve veri aktarımı projelerinde yüksek performanslı altyapı çözümleri sunuyoruz. Cat5e, Cat6e, Cat6a, Cat7 UTP – FTP ve fiber optik kablolama uygulamalarında uzman kadromuzla kaliteli ve uzun ömürlü sistemler kuruyoruz. Tüm kablolama işlemlerinde, profesyonel ekipman ve yöntemlerle en iyi sinyal kalitesini elde edecek şekilde çalışıyor, ağ güvenliğinizi ve veri iletim hızınızı maksimum seviyeye çıkarıyoruz.</p>
        </div>
      </section>
      <section className="hizmet-container">
        <div className="hizmet-content">
          <h2>KNX Aydınlatma Mekanik Otomasyon</h2>
          <div className="orange-line"></div>
          <p>KNX standartlarına uygun aydınlatma ve mekanik otomasyon çözümleri sunuyoruz. Aydınlatma kontrolü, perde-panjur yönetimi ve HVAC entegrasyonu gibi akıllı sistemlerle mekânlarınıza güvenilir, enerji verimli ve kullanıcı dostu otomasyon altyapıları sağlıyoruz.</p>
        </div>
        <div className="circle-image">
          <img id="circle-img" src="/images/header3.jpg" alt="CCTV, Ip ve Telefon Görseli" />
        </div>
      </section>
      <section className="hizmet-container">
        <div className="circle-image">
          <img id="circle-img" src="/images/header3.jpg" alt="Alt Yapı ve Kablolama Görseli" />
        </div>
        <div className="hizmet-content">
          <h2>Akıllı Anahtar Aydınlatma Otomasyon</h2>
          <div className="orange-line"></div>
          <p>Akıllı anahtar sistemleri ve aydınlatma otomasyon çözümleri sunuyoruz. Mekânlarınıza modern, enerji tasarruflu ve kullanıcı dostu kontrol altyapıları kurarak ışık yönetimini tek dokunuşla daha akıllı hale getiriyoruz.</p>
        </div>
      </section>

      

      
      </div>
      <Footer />
    </>
  );
};

export default Services; 